import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { StorageService } from '../../../../shared/services';

interface IErrors {
  required?: string;
}

interface IConfig {
  disabled: boolean;
  selected: { value: string; label: string };
}
@Component({
  selector: 'app-select',
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.scss']
})
export class SelectComponent implements OnInit {

  @Input() public data;
  @Input() public placeHolder;
  @Input() public group: FormGroup;
  @Input() public control: FormControl | any;
  @Output() public onChange = new EventEmitter<string>();
  @Input() public errorMessage: IErrors; /**Error Messages of perticular input */
  @Input() public appearance = 'standard';
  @Input() public config: IConfig | any;
  @Input() public panelClass = '';
  @Input() public label = '';
  @Input() public formFieldClass = '';
  constructor(
    public storageService: StorageService
  ) { }

  ngOnInit() {
    if (this.config && this.config.disabled) {
      this.control.setValue(this.config.selected.value);
    }
  }

  fieldRequired() {
    return this.storageService.get('language') === 'Hindi' ? 'जवाब आवश्यक है' : 'Field Required';
  }
  /**On change value return */
  onValueChange(event) {
    this.onChange.emit(event);
  }

}
